export default "__VITE_ASSET__52751eaa__"